<template>
  <div>
    <el-dialog :title="$t('message.propertyEditForm')" :close-on-click-modal="false"
      :visible.sync="$parent.attributeDialogVisible" width="800px" center>
      <div class="attribute">
        <!-- 属性选择 -->
        <div class="tabs">
          <!-- 网站属性选择 -->
          <el-button :type="selected == 1 ? 'primary' : 'info'" size="small" @click="selected = 1">{{
            $t("message.websitePropertySelection") }}</el-button>
          <!-- 人工编辑属性
          <el-button :type="selected == 2 ? 'primary' : 'info'" size="small" @click="selected = 2">{{
            $t("message.manuallyEditProperties") }}</el-button> -->
        </div>
        <!-- 商品属性 -->
        <div class="goods" v-if="selected == 1">
          <div class="item" v-for="(item, index) in specification" :key="index">
            <div class="key">{{ item.keyC }}：</div>
            <div class="value">
              <div class="items" v-for="(items, indexs) in item.valueC" :key="indexs">
                <div class="pic" v-if="items.picUrl" :class="{ pitch: item.index == indexs }"
                  @click="checked(index, indexs, items.picUrl)">
                  <img :src="items.picUrl" alt="" />
                  <p>{{ items.name }}</p>
                </div>

                <el-button type="info" size="mini" :class="{ dark: item.index == indexs }" @click="checked(index, indexs)"
                  v-else>{{ items.name }}</el-button>
              </div>
            </div>
          </div>
        </div>
        <!-- 人工编辑属性 -->
        <div class="editAttribute" v-else>
          <!-- 添加 -->
          <div class="add">
            <el-button size="mini" type="success" @click="add">{{
              $t("message.add")
            }}</el-button>
          </div>
          <!-- 列表 -->
          <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#EDEFF4  ' }">
            <!-- 属性名称 -->
            <el-table-column prop="date" :label="$t('message.attributeName')" width="280" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.key">
                  onfocus="this.select()"</el-input>
              </template>
            </el-table-column>

            <!-- 具体属性值 -->
            <el-table-column :label="$t('message.specificAttributeValue')" width="280" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.value" onfocus="this.select()"></el-input>
              </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column prop="address" :label="$t('message.operation')" align="center">
              <template slot-scope="scope">
                <!-- 删除 -->
                <el-button size="mini" class="dark" type="primary" @click="del(scope.$index)">{{ $t("message.delete")
                }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="$parent.attributeDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      selected: 1,
      tableData: [{ key: "", value: "" }],
      specification: [],
      indexs: [],
      picUrl: "",
      goodsInventory: {},

    };
  },
  created() {
    if (this.detail != null) {
      this.goodsParticulars();
    }
  },
  mounted() { },
  methods: {
    // 商品详情
    goodsParticulars() {
      let timestamp = Math.floor(new Date().valueOf() / 1000)
      let sign = 'wakanda forever!@9523`'
      let datas = {
        shop_type: this.detail.from_platform,
        goods_id: this.detail.goods_id,
        timestamp,
        sign: this.$md5(`${sign}${timestamp}${sign}`)
      };
      this.$api.clienteleApi.goodsAttribute(datas).then((res) => {
        if (res.data[0].goodsInventory == false) {
          this.$parent.attributeDialogVisible = false
          return this.$message.error('商品已下架')
        }
        this.specification = res.data[0].specification;
        this.goodsInventory = res.data[0].goodsInventory
        this.specification.forEach((item, index) => {
          item.valueC.forEach((items, indexs) => {
            if (this.detail.detail_y != false && this.detail.detail_y != null) {
              if (items.name == this.detail.detail_y[index].value) {
                item.index = indexs;
              }
            }
          });
        });
        if (this.detail.detail_y != undefined && this.detail.detail_y != false) {
          this.tableData = JSON.parse(JSON.stringify(this.detail.detail_y));
        }
      });
    },
    // 新增
    add() {
      this.tableData.push({ key: "", value: "" });
    },
    // 删除
    del(i) {
      this.tableData.splice(i, 1);
    },
    //选择属性
    checked(index, indexs, pic) {
      if (pic) {
        this.picUrl = pic;
      }
      this.specification[index].index = indexs;
      this.$forceUpdate();
    },
    // 查找价格
    searchPricr(data) {
      let str = "";
      var specId = '';
      data.forEach((item) => {
        str += item.value + "㊖㊎";
      });
      str = str.substr(0, str.length - 2);
      for (let i = 0; i < this.goodsInventory.length; i++) {
        if (this.goodsInventory[i].keyC == str) {
          if (this.detail.from_platform == '1688') {
            specId =
              this.goodsInventory[i].valueC[0].specId;
          } else {
            specId =
              this.goodsInventory[i].valueC[0].skuId;

          }

          break;
        } else {
          specId = "";
        }
      }

      this.$forceUpdate();

      this.$parent.receiveAttributeEdit(data, this.picUrl, specId);
    },
    //保存
    save() {
      let specification = [];
      // 网络属性选择
      if (this.selected == 1) {
        this.specification.forEach((item) => {
          if (item.index != null) {
            specification.push({
              key: item.keyC,
              value: item.valueC[item.index].name,
            });
          }
        });
        if (specification == false)
          return this.$message.error("未选择属性无法保存");
        this.searchPricr(specification)

      } else {
        // // 自定义属性
        // this.$parent.receiveAttributeEdit(this.tableData, "", this.goodsInventory);
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.goods {
  .item {
    margin-top: 35px;

    .key {
      margin-bottom: 20px;
      font-size: 16px;
    }

    .value {
      display: flex;
      flex-wrap: wrap;

      .items {
        margin: 0 10px 10px 0;
        cursor: pointer;
      }

      .pic {
        img {
          width: 60px;
          height: 60px;
          margin-bottom: 5px;
        }

        p {
          text-align: center;
          font-size: 12px;
        }
      }

      .pitch {
        img {
          border: 1px solid #c35257;
        }

        color: #c35257;
      }
    }
  }
}

.editAttribute {
  .add {
    margin: 20px 0;
    text-align: right;
  }
}
</style>